import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, concat } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ReadConfigService } from './read-config.service';
import * as CryptoJS from 'crypto-js';
import { Global } from '../../global.constants';
import { Utility } from '../../utility';
import { DBkeys } from '../auth/db-keys';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient, private readConfigService: ReadConfigService) { }

  readonly rootUrl = this.readConfigService.getApiUrl();
  readonly httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
  reqNoAuthHeader = new HttpHeaders({ 'No-Auth': 'True' });
  readonly cryptoKey = 'MSRA';

  UserInfo(): any {
    const userInfo = {
      encryptOrg: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_ORGID)),
      encryptUsr: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_USER))
    };
    return userInfo;
  }

  getUserName(): any {
    if (sessionStorage.getItem('id_token_claims_obj') === null) {
      return '';
    }
    const claims = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
    return claims.sub ? claims.sub : '';
  }

  setLoginTime(): any {
    if (sessionStorage.getItem('id_token_claims_obj')) {
      const claims = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
      sessionStorage.setItem('loginTime', claims.iat);
    }
  }

  getLoginTime(): any {
    if (sessionStorage.getItem('loginTime')) {
      return sessionStorage.getItem('loginTime');
    }
  }

  getRolesList(): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    const url = this.rootUrl + Global.BASE_ROLES_LIST_ENDPOINT;
    return this.http.post<any>(url, obj, this.httpOptions)
      .pipe(map((response: any) => response),
        catchError(this.handleError));
  }

  getContactRolesList(): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    const url = this.rootUrl + Global.BASE_CONTACT_ROLES_LIST_ENDPOINT;
    return this.http.post<any>(url, obj, this.httpOptions)
      .pipe(map((response: any) => response),
        catchError(this.handleError));
  }

  getUsers(): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    const url = this.rootUrl + Global.BASE_USER_ENDPOINT;
    return this.http.post<any>(url, obj, this.httpOptions)
      .pipe(map((response: any) => response),
        catchError(this.handleError));
  }

  addUpdateUser(model: any, isNew: boolean): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo, model };
    const url = this.rootUrl + (isNew ? Global.BASE_USER_ENDPOINT_ADDNEW : Global.BASE_USER_ENDPOINT_UPDATE);
    return this.http.post<any>(url, obj, this.httpOptions)
      .pipe(map((response: any) => response),
        catchError(this.handleError));
  }

  getUserById(id: any): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo, id };
    const url = this.rootUrl + Global.BASE_ALL_USER_ENDPOINT;
    return this.http.post<any>(url, obj, this.httpOptions)
      .pipe(map((response: any) => response),
        catchError(this.handleError));
  }

  validateEmail(email: any): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo, email };
    const url = this.rootUrl + Global.BASE_VALIDATE_EMAIL_ENDPOINT;
    return this.http.post<any>(url, obj, this.httpOptions)
      .pipe(map((response: any) => response),
        catchError(this.handleError));
  }

  deleteUsersData(userId: any, userEmail: any): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo, Id: userId, EmailAddress: userEmail };
    const url = this.rootUrl + Global.BASE_DLT_USERS_USER_ENDPOINT;
    return this.http.post<any>(url, obj, this.httpOptions)
      .pipe(map((response: any) => response as any),
        catchError(this.handleError));
  }

  getOrgProfile(): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    const url = this.rootUrl + Global.BASE_ALL_ORGINFO_ENDPOINT;
    return this.http.post<any>(url, obj, this.httpOptions)
      .pipe(map((response: any) => response),
        catchError(this.handleError));
  }

  encrypt(msg: any, type: any) {
    const randomKey = Array.from(Array(16), () => Math.floor(Math.random() * 36).toString(36)).join('');
    var key = CryptoJS.enc.Utf8.parse(randomKey);
    const randomVector = Array.from(Array(16), () => Math.floor(Math.random() * 36).toString(36)).join('');
    var iv = CryptoJS.enc.Utf8.parse(randomVector);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(msg), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    const result = CryptoJS.enc.Base64.stringify(iv.concat(encrypted.ciphertext).concat(key));
    const encodedVal = encodeURIComponent(result);
    return type === 'post' ? result : encodedVal;
  }

  decryptData(encryptData: any, passPhrase: any): any {
    const key = CryptoJS.enc.Utf8.parse(passPhrase);
    const iv = CryptoJS.enc.Utf8.parse(passPhrase);
    const decrypted = CryptoJS.AES.decrypt(encryptData, key,
      {
        keySize: 128 / 8,
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  private handleError(error: Response) {
    return throwError(error || 'Server error');
  }
}
